import React from 'react'
import pix1 from '../components/img/pix1.png'
import pix2 from '../components/img/pix2.png'
import pix3 from '../components/img/pix3.png'
import pix4 from '../components/img/pix4.png'
import pix5 from '../components/img/pix5.png'
import pix6 from '../components/img/pix6.png'
import pix7 from '../components/img/pix7.png'
import pix8 from '../components/img/pix8.png'
import pix9 from '../components/img/pix9.png'
import pix10 from '../components/img/pix10.png'
import pix11 from '../components/img/pix11.png'
import pix12 from '../components/img/pix12.png'


export const Whykimaye = () => {
  return (
      <>
      <div style={{width:"100%",margin:"auto"}}>
          <img src={pix1} style={{marginTop:"-5px"}} />
          <img src={pix2} style={{marginTop:"-5px"}} />
          <img src={pix3} style={{marginTop:"-5px"}} />
          <img src={pix4} style={{marginTop:"-5px"}} />
          <img src={pix5} style={{marginTop:"-5px"}} />
          <img src={pix6} style={{marginTop:"-5px"}} />
          <img src={pix7} style={{marginTop:"-5px"}} />
          <img src={pix8} style={{marginTop:"-5px"}} />
          <img src={pix9} style={{marginTop:"-5px"}} />
          <img src={pix10} style={{marginTop:"-5px"}} />
          <img src={pix11} style={{marginTop:"-5px"}} />
          <img src={pix12} style={{marginTop:"-5px"}} />
      
      </div>
      </>
    
  )
}
